import React from 'react';
import Component from './Component';
import Input from './TextInput';

export default class SearchInput extends Component {

	static filterDelay  = true;

	static defaultProps = {
		placeholder: 'Hledat'
	};

	render() {
		return (
			<div className="has-feedback has-feedback-left">
					<Input className="form-control" {...this.props} />
					<div className="form-control-feedback">
						<i className="fa fa-search"></i>
					</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/reactis/reactis-inputs/SearchInput.js